/**
 * Magic-string lockbox for the SDK integrations bundle (PROD-861).
 *
 * Every literal here is copied verbatim from Flutter — see
 * `docs/CONVERSIONS/menu-sdk-integrations/CONVERSION_NOTES.md`.
 */

// ─── Intercom ────────────────────────────────────────────────────────────────
// Flutter `menu_container_screen.dart:117-122`.

export const INTERCOM_APP_ID = 'odr7pw7c';

// ─── Mixpanel events ─────────────────────────────────────────────────────────
// Flutter `MixPanelEvents` enum used at lines 287-385 of menu_container_screen.

export const MIXPANEL_EVENT = {
  DASHBOARD: 'DASHBOARD',
  STUDIO: 'STUDIO',
  PATIENTS: 'PATIENTS',
  CALENDAR: 'CALENDAR',
  USERS: 'USERS',
  REPORTS: 'REPORTS',
  STOCK: 'STOCK',
  BILLING: 'BILLING',
  ACCOUNT_SETTINGS: 'ACCOUNT_SETTINGS',
  ORGANIZATION_SETTINGS: 'ORGANIZATION_SETTINGS',
} as const;

export type MixpanelEvent = (typeof MIXPANEL_EVENT)[keyof typeof MIXPANEL_EVENT];

/**
 * Route-path → Mixpanel-event mapping. Used by the route observer in
 * `<AppIntegrations />` to fire one event per top-level module open.
 *
 * Keys match `react-router-dom` path prefixes (without trailing slash).
 * The observer matches on `location.pathname.startsWith(prefix)` and
 * tracks the longest matching prefix.
 */
export const ROUTE_TO_MIXPANEL_EVENT: Array<{
  prefix: string;
  event: MixpanelEvent;
}> = [
  { prefix: '/billing', event: MIXPANEL_EVENT.BILLING },
  { prefix: '/patients', event: MIXPANEL_EVENT.PATIENTS },
  { prefix: '/scheduling', event: MIXPANEL_EVENT.CALENDAR },
  { prefix: '/clinical', event: MIXPANEL_EVENT.STUDIO },
  { prefix: '/reports', event: MIXPANEL_EVENT.REPORTS },
  { prefix: '/stock', event: MIXPANEL_EVENT.STOCK },
  { prefix: '/settings', event: MIXPANEL_EVENT.ORGANIZATION_SETTINGS },
  { prefix: '/account', event: MIXPANEL_EVENT.ACCOUNT_SETTINGS },
  { prefix: '/dashboard', event: MIXPANEL_EVENT.DASHBOARD },
];

// ─── Versioning ──────────────────────────────────────────────────────────────
// Flutter `login_data_source_impl.dart:470` + `api_constants.dart:566`.

export const URL_GET_APP_VERSION_BY_PLATFORM =
  '/api/Versioning/GetAppVersionByPlatform';

/** Body field value for web platform. Flutter mobile sends 'Android' / 'iOS'. */
export const VERSIONING_PLATFORM_WEB = 'Web';

/** Body field value matching the `AppType` header we already inject. */
export const VERSIONING_APP_TYPE = 'Practice Management';

// ─── Push notification ───────────────────────────────────────────────────────
// React adaptation: gate on first user gesture after auth (modern browsers
// reject requestPermission() called outside a user-gesture stack). Flutter's
// 1s Future.delayed pattern works on mobile because the OS dialog is native;
// browsers require the gesture. See push-permission.tsx for the full reasoning.
// No timing constant needed for the gesture-based approach.

// ─── Roles ───────────────────────────────────────────────────────────────────
// Role-ID constants moved to the canonical home `@/auth/roles` (single source
// of truth, mirrors Flutter `app_constants.dart:721-726`). Import them from
// there — e.g. intercom skips super-admins via `SCRIPS_ADMIN_ROLE`.
